import { memo, ReactElement } from 'react';
import AccordionCertification from './accordion-applicant';
import DocumentVisualization from './document-visualization';
import PrintDocument from './print-document';
import { CertificationStep } from 'civil-status/constants/certification-step';
import DocumentList from './document-search';

interface ActiveStepProps {
  step?: CertificationStep;
  onBack: () => void;
  onNext: () => void;
}
const ActiveStepComponent = ({ step, onBack, onNext }: ActiveStepProps): ReactElement => {
  switch (step) {
    case CertificationStep.ApplicantAccountholder:
      return <AccordionCertification />;
    case CertificationStep.Search:
      return <DocumentList onBack={onBack} />;
    case CertificationStep.Visualize:
      return <DocumentVisualization onBack={onBack} onNext={onNext} />;
    case CertificationStep.ChooseCertificate:
      return <PrintDocument onBack={onBack} />;
    default:
      return <></>;
  }
};

ActiveStepComponent.displayName = 'Active step component';

const ActiveStep = memo(ActiveStepComponent) as typeof ActiveStepComponent;

export default ActiveStep;
